query preencherInformacoesNecessariasDistribuicaoPasta($where: CompromissoModelFilterInput) {
    model: compromisso(
        where: $where
    ) {
        codigo
        fluxo {
            pasta {
                agencia2 {
                    codigo
                    nome
                    numero
                    regional
                    estado {
                        sigla
                    }
                    porte
                    label
                    emails {
                        codigo
                        email
                    }
                }
                conta
                contrarioPrincipal {
                    codigo
                    nome
                }
                responsavelNegocial {
                    codigo
                    nome
                }
                gerenteNegocialResponsavel {
                    codigo
                    nome
                }
                responsavelProcessual {
                    codigo
                    nome
                }
                carteirasContratos {
                    codigo
                    contrato
                    original
                    vigente
                    carteira {
                        codigo
                        nome
                        tipo
                        label
                    }
                }
                carteiraContratoVigente {
                    contrato
                    carteira {
                        codigo
                        nome
                        tipo
                        label
                    }
                }
                numeroCnj
            }
        }
    }
}